// src/modules/app-views/crm/pages/Boards/actions/actionButton.js

import { PlusOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import crmService from '../../../service';

const crmInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new_group',
    tooltip: 'new_funnels_group',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    onClick: async () => {
      const boardGroups = crmService.getBoardGroups();
      const label = `${translateX('funnels_group')} #${(boardGroups?.length || 0) + 1}`;
      await crmService.addBoardGroup({ label });
    },

    dropdownItems: [],
  };
};

export default crmInitActionButton;
